import { useGenerate } from '@/hooks/use-generate';
import type { GenerateData, GenerateResponseData } from '@/hooks/use-generate';
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline';
import type { SyntheticEvent } from 'react';

export function GenerateObjectForm({
  dataClassUuid,
  schema,
  onSuccess,
}: {
  dataClassUuid: string;
  schema: any;
  onSuccess: (data: GenerateResponseData) => void;
}) {
  const generateMutation = useGenerate();

  function handleGenerateSubmit(event: SyntheticEvent) {
    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const formData = new FormData(target);
    const queryText = (formData.get('queryText') ?? '') as string;

    const generateData: GenerateData = {
      dataClassUuid,
      formSchema: schema,
      query: queryText,
    };

    generateMutation.mutate(generateData, {
      onSuccess,
    });
  }

  return (
    <div>
      <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
        Create Object
      </h3>
      <form
        className="mt-2 sm:flex flex-col gap-2"
        onSubmit={handleGenerateSubmit}
      >
        <div className="w-full sm:max-w-xs">
          <label htmlFor="queryText" className="sr-only">
            Message
          </label>
          <textarea
            rows={5}
            name="queryText"
            id="queryText"
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:ring-0"
            placeholder="i.e. Give me articles with the name Test"
          />
        </div>
        <button
          type="submit"
          className="mt-3 inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3 sm:mt-0 sm:w-auto self-end  dark:bg-indigo-900 dark:text-indigo-100 dark:hover:bg-indigo-700"
        >
          {generateMutation.isLoading && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          )}
          <ChatBubbleOvalLeftEllipsisIcon
            className="w-5 h-5"
            aria-hidden={true}
          />
          <span className="sr-only">Ask</span>
        </button>
      </form>
    </div>
  );
}
